import {
  MainCategory,
  Category,
  SubCategory,
  SortCategoriesRequest,
  Category1,
  SubCategory1,
  MainCategory1,
  SubCategory1Body,
  IPopulerInYourCountry,
} from './../models/category';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environment';
import { ICount } from '../models/interfaces/count.model';
import { IMainCategories } from 'projects/admin/src/app/components/panel/category/Main Categories/interfaces/mainCategories.interface';
import { ICategories, ICategoriesResponse } from 'projects/admin/src/app/components/panel/category/Categories/interfaces/categories.interface';
import { ISubCategories, ISubCategoriesResponse } from 'projects/admin/src/app/components/panel/category/Sub Categories/interfaces/sub-category.interface';
@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  // Define API
  private apiURL = environment.apiUrl;
  private url = `${this.apiURL}categories/`;
  private urlUser = `${this.apiURL}user-categories/`;

  mainCategories = new BehaviorSubject<any>(null)
  constructor(private http: HttpClient, private cookieService: CookieService) { }

  /*==============================MainCaetgories================================*/
  getMainCategories(queryParam = ''): Observable<any> {
    return this.http.get<any>(
      `${this.url}main-categories?${queryParam}`
    );
  }
  getUserMainCategories(queryParam = ''): Observable<any> {
    return this.http.get<any>(
      `${this.urlUser}main-categories${queryParam}`
    );
  }
  getSingleUserMainCategory(id: any): Observable<MainCategory1> {
    return this.http.get<MainCategory1>(`${this.urlUser}main-categories/${id}`);
  }
  getSingleMainCategory(id: any): Observable<IMainCategories> {
    return this.http.get<IMainCategories>(`${this.url}main-categories/${id}`);
  }
  createMainCategory(mainObj: IMainCategories): Observable<MainCategory> {
    return this.http.post<MainCategory>(`${this.url}main-categories`, mainObj);
  }
  updateMainCategory(newData: any, id?: string): Observable<MainCategory> {
    return this.http.patch<any>(
      `${this.url}main-categories/${id}`,
      newData
    );
  }
  sortMainCategory(payload: SortCategoriesRequest): Observable<MainCategory[]> {
    return this.http.patch<MainCategory[]>(
      `${this.url}main-categories/sort`,
      payload
    );
  }
  deleteMainCategory(id: any): Observable<MainCategory> {
    return this.http.delete<MainCategory>(`${this.url}main-categories/${id}`);
  }
  restoreMainCategory(id: any): Observable<any[]> {
    return this.http.patch<any[]>(`${this.url}redeem-main-categories/${id}`, {});
  }
  /*==============================Caetgories================================*/
  getCategories(queryParam = ''): Observable<ICategoriesResponse> {
    return this.http.get<ICategoriesResponse>(`${this.url}category?${queryParam}`);
  }
  getUserCategories(queryParam = ''): Observable<Category> {

    return this.http.get<Category>(`${this.urlUser}category${queryParam}`);
  }
  getSingleCategory(id: any): Observable<ICategories> {
    return this.http.get<ICategories>(`${this.url}category/${id}`);
  }

  getSingleUserCategory(slug: any): Observable<Category1> {
    return this.http.get<Category1>(`${this.urlUser}category/${slug}`);

  }
  createCategory(categoryObj: Category1): Observable<Category> {
    return this.http.post<Category>(`${this.url}category`, categoryObj);
  }
  updateCategory(newData: Category1, id?: string): Observable<Category> {
    return this.http.patch<Category>(
      `${this.url}category/${id}`,
      newData
    );
  }
  sortCategory(payload: SortCategoriesRequest): Observable<Category[]> {
    return this.http.patch<Category[]>(`${this.url}categories/sort`, payload);
  }
  deleteCategory(id: any): Observable<Category> {
    return this.http.delete<Category>(`${this.url}category/${id}`);
  }
  restoreCategory(id: any): Observable<any[]> {
    return this.http.patch<any[]>(
      `${this.url}redeem-category/${id}`,
      {}
    );
  }
  /*==============================SubCaetgories================================*/
  getSubCategories(queryParam = ''): Observable<ISubCategoriesResponse> {
    return this.http.get<ISubCategoriesResponse>(`${this.url}sub-categories/?${queryParam}`);
  }
  getUserSubCategories(queryParam = ''): Observable<SubCategory> {
    return this.http.get<SubCategory>(`${this.urlUser}sub-categories/${queryParam}`);
  }
  getSingleSubCategories(id: any): Observable<ISubCategories> {
    return this.http.get<ISubCategories>(`${this.url}sub-categories/${id}`);
  }
  getSingleUserSubCategories(slug: any): Observable<SubCategory1Body> {
    return this.http.get<SubCategory1Body>(`${this.urlUser}sub-categories/${slug}`);
  }
  getSuggestionSubCategoryInCountry(param = {}): Observable<IPopulerInYourCountry> {
    const params = new HttpParams({ fromObject: param });
    return this.http.get<IPopulerInYourCountry>(`${this.urlUser}suggestions?${params}`);
  }
  createSubCategory(subCatyObj: ISubCategories): Observable<ISubCategories> {
    return this.http.post<ISubCategories>(
      `${this.url}sub-categories`,
      subCatyObj
    );
  }

  updateSubCategory(newData: ISubCategories, id: string): Observable<SubCategory> {

    return this.http.patch<SubCategory>(
      `${this.url}sub-categories/${id}`,
      newData
    );
  }
  sortSubCategory(payload: SortCategoriesRequest): Observable<SubCategory[]> {
    return this.http.patch<SubCategory[]>(
      `${this.url}sub-categories/sort`,
      payload
    );
  }
  deleteSubCategory(id: any): Observable<SubCategory> {
    return this.http.delete<SubCategory>(`${this.url}sub-categories/${id}`);
  }
  restoreSubCategory(id: any): Observable<any[]> {
    return this.http.patch<any[]>(`${this.url}redeem-sub-categories/${id}`, {});
  }
  getCount(name: string, id: string | number = ''): Observable<ICount<string>[]> {
    return this.http.get<ICount<string>[]>(`${this.url}count/${name}?referenceId=${id}`).pipe(
      catchError((err) => {
        throw new Error(err.message);
      })
    );
  }
}
